import styled from 'styled-components'
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  typography,
  TypographyProps,
  position,
  PositionProps,
} from 'styled-system'

export interface IFlexProps
  extends SpaceProps,
    LayoutProps,
    ColorProps,
    FlexboxProps,
    PositionProps,
    TypographyProps {
  className?: string
  onClick?: (event: React.MouseEvent) => void
}

export const Flex = styled.div<IFlexProps>`
  display: flex;
  ${position}
  position: relative;
  ${space}
  ${layout}
  ${color}
  ${flexbox}
  ${typography}
`
